import React from "react";
import Card from "react-bootstrap/Card";
import { PiPersonSimpleHike, PiBooks, PiChefHat } from "react-icons/pi";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
  <blockquote className="blockquote mb-0">
    <p style={{ textAlign: "left" }}>
      Hi everyone! I'm <span className="teal">Renee</span> from{" "}
      <span className="teal">the New York Metropolitan area</span>.
      <br /><br />
      I'm a web developer who loves transforming great designs into reliable, intuitive, and good-looking websites. I've used too many terrible sites that desperately need help, so I'm passionate about creating excellent user experiences.
      <br /><br />
      I primarily work with <span className="teal">WordPress and Elementor</span>, but I'm also familiar with other WordPress builders, Squarespace, and <span className="teal">Shopify</span>.
      <br /><br />
      Currently, I'm doing contract work as a{" "}
      <span className="teal">WordPress Developer and web admin</span> with{" "}
      <span className="teal">Datachunk Media Designs</span>.
      <br /><br />
      I have a BS in <span className="teal">Oceanography</span> from{" "}
      <span className="teal">the United States Naval Academy</span> and have earned certificates in both <span className="teal">Cybersecurity</span> and{" "}
      <span className="teal">UX Design</span>. I've also built several web applications with <span className="teal">Node.js</span>,{" "}
      <span className="teal">React</span>, and <span className="teal">Next</span> to deepen my full-stack development skills.
      <br /><br />
      When I'm not working, I love doing things to spark my creativity, like:
      <br /><br />
      <ul>
        <li className="about-activity">
          <PiPersonSimpleHike /> Hiking
        </li>
        <li className="about-activity">
          <PiBooks /> Reading
        </li>
        <li className="about-activity">
          <PiChefHat /> Cooking
        </li>
      </ul>
    </p>
  </blockquote>
</Card.Body>
    </Card>
  );
}

export default AboutCard;
